// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { ColumnTotals, DashboardSource, DashboardVersionReason, SnapshotTotals } from "../dashboard/domain.generated";
import type { BrandDTO, BrandFontDTO, BrandPickDTO, BrandProposalDTO, BrandProposalFontDTO, BrandProposalLogoDTO, DashboardDTO, DashboardVersionDTO, DatasetRunDTO, DeleteDashboardResponse, DeleteDocumentResponse, DocumentDTO, PreviewDataDTO, PublicDashboardDTO, RenderDTO, RenderWidgetDTO, RowsPageDTO, SlotCheckDTO, StoredRenderDTO, VersionDTO } from "../dashboard/dto.generated";
export const addTagTypes = ["dashboards", "studio"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiProjectsByProjectIdDashboards: build.query<
        GetApiProjectsByProjectIdDashboardsApiResponse,
        GetApiProjectsByProjectIdDashboardsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/dashboards`,
        }),
        providesTags: ["dashboards"],
      }),
      postApiProjectsByProjectIdDashboards: build.mutation<
        PostApiProjectsByProjectIdDashboardsApiResponse,
        PostApiProjectsByProjectIdDashboardsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/dashboards`,
          method: "POST",
          body: queryArg.dashboardCreateDashboardRequest,
        }),
        invalidatesTags: ["dashboards"],
      }),
      postApiProjectsByProjectIdDashboardsPreviewData: build.mutation<
        PostApiProjectsByProjectIdDashboardsPreviewDataApiResponse,
        PostApiProjectsByProjectIdDashboardsPreviewDataApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/dashboards/preview-data`,
          method: "POST",
          body: queryArg.dashboardPreviewDataRequest,
        }),
        invalidatesTags: [],
      }),
      postApiProjectsByProjectIdDashboardsWidgetRender: build.mutation<
        PostApiProjectsByProjectIdDashboardsWidgetRenderApiResponse,
        PostApiProjectsByProjectIdDashboardsWidgetRenderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/dashboards/widget-render`,
          method: "POST",
          body: queryArg.dashboardRenderWidgetRequest,
        }),
        invalidatesTags: [],
      }),
      getApiProjectsByProjectIdDashboardsAndDashboardId: build.query<
        GetApiProjectsByProjectIdDashboardsAndDashboardIdApiResponse,
        GetApiProjectsByProjectIdDashboardsAndDashboardIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/dashboards/${encodeURIComponent(String(queryArg.dashboardId))}`,
        }),
        providesTags: ["dashboards"],
      }),
      putApiProjectsByProjectIdDashboardsAndDashboardId: build.mutation<
        PutApiProjectsByProjectIdDashboardsAndDashboardIdApiResponse,
        PutApiProjectsByProjectIdDashboardsAndDashboardIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/dashboards/${encodeURIComponent(String(queryArg.dashboardId))}`,
          method: "PUT",
          body: queryArg.dashboardUpdateDashboardRequest,
        }),
        invalidatesTags: ["dashboards"],
      }),
      deleteApiProjectsByProjectIdDashboardsAndDashboardId: build.mutation<
        DeleteApiProjectsByProjectIdDashboardsAndDashboardIdApiResponse,
        DeleteApiProjectsByProjectIdDashboardsAndDashboardIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/dashboards/${encodeURIComponent(String(queryArg.dashboardId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["dashboards"],
      }),
      postApiProjectsByProjectIdDashboardsAndDashboardIdRefresh: build.mutation<
        PostApiProjectsByProjectIdDashboardsAndDashboardIdRefreshApiResponse,
        PostApiProjectsByProjectIdDashboardsAndDashboardIdRefreshApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/dashboards/${encodeURIComponent(String(queryArg.dashboardId))}/refresh`,
          method: "POST",
        }),
        invalidatesTags: ["dashboards"],
      }),
      getApiProjectsByProjectIdDashboardsAndDashboardIdRows: build.query<
        GetApiProjectsByProjectIdDashboardsAndDashboardIdRowsApiResponse,
        GetApiProjectsByProjectIdDashboardsAndDashboardIdRowsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/dashboards/${encodeURIComponent(String(queryArg.dashboardId))}/rows`,
          params: {
            gen: queryArg.gen,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["dashboards"],
      }),
      getApiProjectsByProjectIdDashboardsAndDashboardIdVersions: build.query<
        GetApiProjectsByProjectIdDashboardsAndDashboardIdVersionsApiResponse,
        GetApiProjectsByProjectIdDashboardsAndDashboardIdVersionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/dashboards/${encodeURIComponent(String(queryArg.dashboardId))}/versions`,
        }),
        providesTags: ["dashboards"],
      }),
      getApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumber:
        build.query<
          GetApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumberApiResponse,
          GetApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumberApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/dashboards/${encodeURIComponent(String(queryArg.dashboardId))}/versions/${encodeURIComponent(String(queryArg["number"]))}`,
          }),
          providesTags: ["dashboards"],
        }),
      postApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumberRestore:
        build.mutation<
          PostApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumberRestoreApiResponse,
          PostApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumberRestoreApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/dashboards/${encodeURIComponent(String(queryArg.dashboardId))}/versions/${encodeURIComponent(String(queryArg["number"]))}/restore`,
            method: "POST",
          }),
          invalidatesTags: ["dashboards"],
        }),
      getApiProjectsByProjectIdStudioBrand: build.query<
        GetApiProjectsByProjectIdStudioBrandApiResponse,
        GetApiProjectsByProjectIdStudioBrandApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/brand`,
        }),
        providesTags: ["studio"],
      }),
      putApiProjectsByProjectIdStudioBrand: build.mutation<
        PutApiProjectsByProjectIdStudioBrandApiResponse,
        PutApiProjectsByProjectIdStudioBrandApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/brand`,
          method: "PUT",
          body: queryArg.studioSetBrandRequest,
        }),
        invalidatesTags: ["studio"],
      }),
      postApiProjectsByProjectIdStudioBrandFromSite: build.mutation<
        PostApiProjectsByProjectIdStudioBrandFromSiteApiResponse,
        PostApiProjectsByProjectIdStudioBrandFromSiteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/brand/from-site`,
          method: "POST",
          body: queryArg.studioBrandFromSiteRequest,
        }),
        invalidatesTags: ["studio"],
      }),
      getApiProjectsByProjectIdStudioDocuments: build.query<
        GetApiProjectsByProjectIdStudioDocumentsApiResponse,
        GetApiProjectsByProjectIdStudioDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents`,
        }),
        providesTags: ["studio"],
      }),
      postApiProjectsByProjectIdStudioDocuments: build.mutation<
        PostApiProjectsByProjectIdStudioDocumentsApiResponse,
        PostApiProjectsByProjectIdStudioDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents`,
          method: "POST",
          body: queryArg.studioCreateDocumentRequest,
        }),
        invalidatesTags: ["studio"],
      }),
      getApiProjectsByProjectIdStudioDocumentsAndDocumentId: build.query<
        GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdApiResponse,
        GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents/${encodeURIComponent(String(queryArg.documentId))}`,
        }),
        providesTags: ["studio"],
      }),
      deleteApiProjectsByProjectIdStudioDocumentsAndDocumentId: build.mutation<
        DeleteApiProjectsByProjectIdStudioDocumentsAndDocumentIdApiResponse,
        DeleteApiProjectsByProjectIdStudioDocumentsAndDocumentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents/${encodeURIComponent(String(queryArg.documentId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["studio"],
      }),
      patchApiProjectsByProjectIdStudioDocumentsAndDocumentId: build.mutation<
        PatchApiProjectsByProjectIdStudioDocumentsAndDocumentIdApiResponse,
        PatchApiProjectsByProjectIdStudioDocumentsAndDocumentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents/${encodeURIComponent(String(queryArg.documentId))}`,
          method: "PATCH",
          body: queryArg.studioUpdateDocumentRequest,
        }),
        invalidatesTags: ["studio"],
      }),
      postApiProjectsByProjectIdStudioDocumentsAndDocumentIdRender:
        build.mutation<
          PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRenderApiResponse,
          PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRenderApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents/${encodeURIComponent(String(queryArg.documentId))}/render`,
            method: "POST",
            body: queryArg.studioRenderDocumentRequest,
          }),
          invalidatesTags: [],
        }),
      getApiProjectsByProjectIdStudioDocumentsAndDocumentIdRenders: build.query<
        GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersApiResponse,
        GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents/${encodeURIComponent(String(queryArg.documentId))}/renders`,
        }),
        providesTags: ["studio"],
      }),
      postApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersRenderIdOpen:
        build.mutation<
          PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersRenderIdOpenApiResponse,
          PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersRenderIdOpenApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents/${encodeURIComponent(String(queryArg.documentId))}/renders/${encodeURIComponent(String(queryArg.renderId))}/open`,
            method: "POST",
          }),
          invalidatesTags: [],
        }),
      postApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersRenderIdVideo:
        build.mutation<
          PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersRenderIdVideoApiResponse,
          PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersRenderIdVideoApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents/${encodeURIComponent(String(queryArg.documentId))}/renders/${encodeURIComponent(String(queryArg.renderId))}/video`,
            method: "POST",
          }),
          invalidatesTags: ["studio"],
        }),
      getApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersions:
        build.query<
          GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsApiResponse,
          GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents/${encodeURIComponent(String(queryArg.documentId))}/versions`,
          }),
          providesTags: ["studio"],
        }),
      postApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersions:
        build.mutation<
          PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsApiResponse,
          PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents/${encodeURIComponent(String(queryArg.documentId))}/versions`,
            method: "POST",
            body: queryArg.studioSaveVersionRequest,
          }),
          invalidatesTags: ["studio"],
        }),
      getApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumber:
        build.query<
          GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumberApiResponse,
          GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumberApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents/${encodeURIComponent(String(queryArg.documentId))}/versions/${encodeURIComponent(String(queryArg["number"]))}`,
          }),
          providesTags: ["studio"],
        }),
      postApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumberRestore:
        build.mutation<
          PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumberRestoreApiResponse,
          PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumberRestoreApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/documents/${encodeURIComponent(String(queryArg.documentId))}/versions/${encodeURIComponent(String(queryArg["number"]))}/restore`,
            method: "POST",
            body: queryArg.studioRestoreVersionRequest,
          }),
          invalidatesTags: ["studio"],
        }),
      postApiProjectsByProjectIdStudioRender: build.mutation<
        PostApiProjectsByProjectIdStudioRenderApiResponse,
        PostApiProjectsByProjectIdStudioRenderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/studio/render`,
          method: "POST",
          body: queryArg.studioRenderRequest,
        }),
        invalidatesTags: [],
      }),
      getApiPublicDashboardsWidgetContentByToken: build.query<
        GetApiPublicDashboardsWidgetContentByTokenApiResponse,
        GetApiPublicDashboardsWidgetContentByTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/public/dashboards/widget-content/${encodeURIComponent(String(queryArg.token))}`,
        }),
        providesTags: ["dashboards"],
      }),
      getApiPublicDashboardsByDashboardId: build.query<
        GetApiPublicDashboardsByDashboardIdApiResponse,
        GetApiPublicDashboardsByDashboardIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/public/dashboards/${encodeURIComponent(String(queryArg.dashboardId))}`,
        }),
        providesTags: ["dashboards"],
      }),
      getApiPublicStudioRendersByToken: build.query<
        GetApiPublicStudioRendersByTokenApiResponse,
        GetApiPublicStudioRendersByTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/public/studio/renders/${encodeURIComponent(String(queryArg.token))}`,
          params: {
            t: queryArg.t,
            paused: queryArg.paused,
          },
        }),
        providesTags: [],
      }),
      getApiPublicStudioRendersByTokenMp4: build.query<
        GetApiPublicStudioRendersByTokenMp4ApiResponse,
        GetApiPublicStudioRendersByTokenMp4ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/public/studio/renders/${encodeURIComponent(String(queryArg.token))}/mp4`,
        }),
        providesTags: [],
      }),
      getApiPublicStudioRendersByTokenPagesAndNumber: build.query<
        GetApiPublicStudioRendersByTokenPagesAndNumberApiResponse,
        GetApiPublicStudioRendersByTokenPagesAndNumberApiArg
      >({
        query: (queryArg) => ({
          url: `/api/public/studio/renders/${encodeURIComponent(String(queryArg.token))}/pages/${encodeURIComponent(String(queryArg["number"]))}`,
        }),
        providesTags: [],
      }),
      getApiPublicStudioRendersByTokenPdf: build.query<
        GetApiPublicStudioRendersByTokenPdfApiResponse,
        GetApiPublicStudioRendersByTokenPdfApiArg
      >({
        query: (queryArg) => ({
          url: `/api/public/studio/renders/${encodeURIComponent(String(queryArg.token))}/pdf`,
        }),
        providesTags: [],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as dashboardApi };
export type GetApiProjectsByProjectIdDashboardsApiResponse =
  /** status 200 OK */ { data: DashboardDashboardDto[] };
export type GetApiProjectsByProjectIdDashboardsApiArg = {
  /** Project ID */
  projectId: string;
};
export type PostApiProjectsByProjectIdDashboardsApiResponse =
  /** status 201 Created */ { data: DashboardDashboardDto };
export type PostApiProjectsByProjectIdDashboardsApiArg = {
  /** Project ID */
  projectId: string;
  /** Create request */
  dashboardCreateDashboardRequest: DashboardCreateDashboardRequest;
};
export type PostApiProjectsByProjectIdDashboardsPreviewDataApiResponse =
  /** status 200 OK */ { data: DashboardPreviewDataDto };
export type PostApiProjectsByProjectIdDashboardsPreviewDataApiArg = {
  /** Project ID */
  projectId: string;
  /** Draft query */
  dashboardPreviewDataRequest: DashboardPreviewDataRequest;
};
export type PostApiProjectsByProjectIdDashboardsWidgetRenderApiResponse =
  /** status 200 OK */ { data: DashboardRenderWidgetDto };
export type PostApiProjectsByProjectIdDashboardsWidgetRenderApiArg = {
  /** Project ID */
  projectId: string;
  /** Hydrated widget HTML */
  dashboardRenderWidgetRequest: DashboardRenderWidgetRequest;
};
export type GetApiProjectsByProjectIdDashboardsAndDashboardIdApiResponse =
  /** status 200 OK */ { data: DashboardDashboardDto };
export type GetApiProjectsByProjectIdDashboardsAndDashboardIdApiArg = {
  /** Project ID */
  projectId: string;
  /** Dashboard ID */
  dashboardId: string;
};
export type PutApiProjectsByProjectIdDashboardsAndDashboardIdApiResponse =
  /** status 200 OK */ { data: DashboardDashboardDto };
export type PutApiProjectsByProjectIdDashboardsAndDashboardIdApiArg = {
  /** Project ID */
  projectId: string;
  /** Dashboard ID */
  dashboardId: string;
  /** Update request */
  dashboardUpdateDashboardRequest: DashboardUpdateDashboardRequest;
};
export type DeleteApiProjectsByProjectIdDashboardsAndDashboardIdApiResponse =
  /** status 200 OK */ { data: DashboardDeleteDashboardResponse };
export type DeleteApiProjectsByProjectIdDashboardsAndDashboardIdApiArg = {
  /** Project ID */
  projectId: string;
  /** Dashboard ID */
  dashboardId: string;
};
export type PostApiProjectsByProjectIdDashboardsAndDashboardIdRefreshApiResponse =
  /** status 200 OK */ { data: DashboardDashboardDto };
export type PostApiProjectsByProjectIdDashboardsAndDashboardIdRefreshApiArg = {
  /** Project ID */
  projectId: string;
  /** Dashboard ID */
  dashboardId: string;
};
export type GetApiProjectsByProjectIdDashboardsAndDashboardIdRowsApiResponse =
  /** status 200 OK */ { data: DashboardRowsPageDto };
export type GetApiProjectsByProjectIdDashboardsAndDashboardIdRowsApiArg = {
  /** Project ID */
  projectId: string;
  /** Dashboard ID */
  dashboardId: string;
  /** Snapshot generation */
  gen: number;
  /** next_cursor of the previous page */
  cursor?: string;
};
export type GetApiProjectsByProjectIdDashboardsAndDashboardIdVersionsApiResponse =
  /** status 200 OK */ { data: DashboardDashboardVersionDto[] };
export type GetApiProjectsByProjectIdDashboardsAndDashboardIdVersionsApiArg = {
  /** Project ID */
  projectId: string;
  /** Dashboard ID */
  dashboardId: string;
};
export type GetApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumberApiResponse =
  /** status 200 OK */ { data: DashboardDashboardVersionDto };
export type GetApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumberApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Dashboard ID */
    dashboardId: string;
    /** Version number */
    number: number;
  };
export type PostApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumberRestoreApiResponse =
  /** status 200 OK */ { data: DashboardDashboardDto };
export type PostApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumberRestoreApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Dashboard ID */
    dashboardId: string;
    /** Version number */
    number: number;
  };
export type GetApiProjectsByProjectIdStudioBrandApiResponse =
  /** status 200 OK */ { data: StudioBrandDto };
export type GetApiProjectsByProjectIdStudioBrandApiArg = {
  /** Project ID */
  projectId: string;
};
export type PutApiProjectsByProjectIdStudioBrandApiResponse =
  /** status 200 OK */ { data: StudioBrandDto };
export type PutApiProjectsByProjectIdStudioBrandApiArg = {
  /** Project ID */
  projectId: string;
  /** The brand */
  studioSetBrandRequest: StudioSetBrandRequest;
};
export type PostApiProjectsByProjectIdStudioBrandFromSiteApiResponse =
  /** status 200 OK */ { data: StudioBrandProposalDto };
export type PostApiProjectsByProjectIdStudioBrandFromSiteApiArg = {
  /** Project ID */
  projectId: string;
  /** The website */
  studioBrandFromSiteRequest: StudioBrandFromSiteRequest;
};
export type GetApiProjectsByProjectIdStudioDocumentsApiResponse =
  /** status 200 OK */ { data: StudioDocumentDto[] };
export type GetApiProjectsByProjectIdStudioDocumentsApiArg = {
  /** Project ID */
  projectId: string;
};
export type PostApiProjectsByProjectIdStudioDocumentsApiResponse =
  /** status 201 Created */ { data: StudioDocumentDto };
export type PostApiProjectsByProjectIdStudioDocumentsApiArg = {
  /** Project ID */
  projectId: string;
  /** The document and its first version */
  studioCreateDocumentRequest: StudioCreateDocumentRequest;
};
export type GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdApiResponse =
  /** status 200 OK */ { data: StudioDocumentDto };
export type GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdApiArg = {
  /** Project ID */
  projectId: string;
  /** Document ID */
  documentId: string;
};
export type DeleteApiProjectsByProjectIdStudioDocumentsAndDocumentIdApiResponse =
  /** status 200 OK */ { data: StudioDeleteDocumentResponse };
export type DeleteApiProjectsByProjectIdStudioDocumentsAndDocumentIdApiArg = {
  /** Project ID */
  projectId: string;
  /** Document ID */
  documentId: string;
};
export type PatchApiProjectsByProjectIdStudioDocumentsAndDocumentIdApiResponse =
  /** status 200 OK */ { data: StudioDocumentDto };
export type PatchApiProjectsByProjectIdStudioDocumentsAndDocumentIdApiArg = {
  /** Project ID */
  projectId: string;
  /** Document ID */
  documentId: string;
  /** The fields to change */
  studioUpdateDocumentRequest: StudioUpdateDocumentRequest;
};
export type PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRenderApiResponse =
  /** status 200 OK */ { data: StudioRenderDto };
export type PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRenderApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Document ID */
    documentId: string;
    /** The period and the text for the narrative slots */
    studioRenderDocumentRequest: StudioRenderDocumentRequest;
  };
export type GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersApiResponse =
  /** status 200 OK */ { data: StudioStoredRenderDto[] };
export type GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Document ID */
    documentId: string;
  };
export type PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersRenderIdOpenApiResponse =
  /** status 200 OK */ { data: StudioRenderDto };
export type PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersRenderIdOpenApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Document ID */
    documentId: string;
    /** Render ID */
    renderId: string;
  };
export type PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersRenderIdVideoApiResponse =
  /** status 202 Accepted */ { data: StudioStoredRenderDto };
export type PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersRenderIdVideoApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Document ID */
    documentId: string;
    /** Render ID */
    renderId: string;
  };
export type GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsApiResponse =
  /** status 200 OK */ { data: StudioVersionDto[] };
export type GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Document ID */
    documentId: string;
  };
export type PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsApiResponse =
  /** status 201 Created */ { data: StudioVersionDto };
export type PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Document ID */
    documentId: string;
    /** The version's content and note */
    studioSaveVersionRequest: StudioSaveVersionRequest;
  };
export type GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumberApiResponse =
  /** status 200 OK */ { data: StudioVersionDto };
export type GetApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumberApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Document ID */
    documentId: string;
    /** Version number, from 1 */
    number: number;
  };
export type PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumberRestoreApiResponse =
  /** status 201 Created */ { data: StudioVersionDto };
export type PostApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumberRestoreApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Document ID */
    documentId: string;
    /** Version number, from 1 */
    number: number;
    /** The note the history shows */
    studioRestoreVersionRequest: StudioRestoreVersionRequest;
  };
export type PostApiProjectsByProjectIdStudioRenderApiResponse =
  /** status 200 OK */ { data: StudioRenderDto };
export type PostApiProjectsByProjectIdStudioRenderApiArg = {
  /** Project ID */
  projectId: string;
  /** The document, its datasets and the text for its slots */
  studioRenderRequest: StudioRenderRequest;
};
export type GetApiPublicDashboardsWidgetContentByTokenApiResponse = unknown;
export type GetApiPublicDashboardsWidgetContentByTokenApiArg = {
  /** Widget render token */
  token: string;
};
export type GetApiPublicDashboardsByDashboardIdApiResponse =
  /** status 200 OK */ { data: DashboardPublicDashboardDto };
export type GetApiPublicDashboardsByDashboardIdApiArg = {
  /** Dashboard ID */
  dashboardId: string;
};
export type GetApiPublicStudioRendersByTokenApiResponse = unknown;
export type GetApiPublicStudioRendersByTokenApiArg = {
  /** Render token */
  token: string;
  /** A video's start, in seconds from the beginning of its timeline */
  t?: number;
  /** 1 (or true) holds a video still at t */
  paused?: string;
};
export type GetApiPublicStudioRendersByTokenMp4ApiResponse = unknown;
export type GetApiPublicStudioRendersByTokenMp4ApiArg = {
  /** Render token */
  token: string;
};
export type GetApiPublicStudioRendersByTokenPagesAndNumberApiResponse = unknown;
export type GetApiPublicStudioRendersByTokenPagesAndNumberApiArg = {
  /** Render token */
  token: string;
  /** Page number, from 1 */
  number: number;
};
export type GetApiPublicStudioRendersByTokenPdfApiResponse = unknown;
export type GetApiPublicStudioRendersByTokenPdfApiArg = {
  /** Render token */
  token: string;
};
export type DomainColumnTotals = ColumnTotals;
export type DomainSnapshotTotals = SnapshotTotals;
export type DomainDashboardSource = DashboardSource;
export type DomainDashboardType = "html" | "widget";
export type DashboardDashboardDto = DashboardDTO;
export type DashboardCreateDashboardRequest = {
  analysis_spec_slug?: string;
  analysis_spec_slugs?: string[];
  content?: string;
  min_role?: string;
  query?: string;
  title?: string;
  type?: DomainDashboardType;
};
export type DashboardPreviewDataDto = PreviewDataDTO;
export type DashboardPreviewDataRequest = {
  query?: string;
};
export type DashboardRenderWidgetDto = RenderWidgetDTO;
export type DashboardRenderWidgetRequest = {
  content?: string;
};
export type DashboardUpdateDashboardRequest = {
  analysis_spec_slugs?: string[];
  content?: string;
  min_role?: string;
  query?: string;
  title?: string;
};
export type DashboardDeleteDashboardResponse = DeleteDashboardResponse;
export type DashboardRowsPageDto = RowsPageDTO;
export type DomainDashboardVersionReason = DashboardVersionReason;
export type DashboardDashboardVersionDto = DashboardVersionDTO;
export type StudioBrandColorsDto = {
  accent?: string;
  background?: string;
  primary?: string;
  text?: string;
};
export type StudioBrandFontDto = BrandFontDTO;
export type StudioBrandDto = BrandDTO;
export type StudioBrandFontUpload = {
  data: string;
  family: string;
  weight?: string;
};
export type StudioSetBrandRequest = {
  body_font?: string;
  colors?: StudioBrandColorsDto;
  fonts?: StudioBrandFontUpload[];
  footer?: string;
  heading_font?: string;
  logo?: string;
  shape?: string;
};
export type StudioBrandPickDto = BrandPickDTO;
export type StudioBrandProposalFontDto = BrandProposalFontDTO;
export type StudioBrandProposalLogoDto = BrandProposalLogoDTO;
export type StudioBrandProposalDto = BrandProposalDTO;
export type StudioBrandFromSiteRequest = {
  fonts_licensed?: boolean;
  save?: boolean;
  url: string;
};
export type StudioDatasetRequest = {
  formats?: {
    [key: string]: string;
  };
  name?: string;
  sources?: string[];
  sql?: string;
};
export type StudioPageRequest = {
  cover?: boolean;
  duration?: number;
  template?: string;
};
export type StudioSlotRequest = {
  facts?: string[];
  fallback?: string;
  key?: string;
  max_words?: number;
};
export type StudioVersionDto = VersionDTO;
export type StudioDocumentDto = DocumentDTO;
export type StudioCreateDocumentRequest = {
  authored_via?: string;
  datasets?: StudioDatasetRequest[];
  kind?: string;
  lang?: string;
  min_role?: string;
  note?: string;
  pages?: StudioPageRequest[];
  slots?: StudioSlotRequest[];
  slug?: string;
  title?: string;
};
export type StudioDeleteDocumentResponse = DeleteDocumentResponse;
export type StudioUpdateDocumentRequest = {
  min_role?: string;
  status?: string;
  title?: string;
};
export type StudioDatasetRunDto = DatasetRunDTO;
export type StudioSlotCheckDto = SlotCheckDTO;
export type StudioRenderDto = RenderDTO;
export type StudioRenderDocumentRequest = {
  /** Format is a video's frame: landscape (the default), portrait or square. A deck or a report ignores it. */
  format?: string;
  narrative?: {
    [key: string]: string;
  };
  period?: string;
  preview?: boolean;
};
export type StudioStoredRenderDto = StoredRenderDTO;
export type StudioSaveVersionRequest = {
  authored_via?: string;
  datasets?: StudioDatasetRequest[];
  lang?: string;
  note?: string;
  pages?: StudioPageRequest[];
  slots?: StudioSlotRequest[];
};
export type StudioRestoreVersionRequest = {
  note?: string;
};
export type StudioRenderRequest = {
  datasets?: StudioDatasetRequest[];
  format?: string;
  kind?: string;
  lang?: string;
  narrative?: {
    [key: string]: string;
  };
  pages?: StudioPageRequest[];
  period?: string;
  preview?: boolean;
  slots?: StudioSlotRequest[];
  title?: string;
};
export type DashboardPublicDashboardDto = PublicDashboardDTO;
export const {
  useGetApiProjectsByProjectIdDashboardsQuery,
  useLazyGetApiProjectsByProjectIdDashboardsQuery,
  usePostApiProjectsByProjectIdDashboardsMutation,
  usePostApiProjectsByProjectIdDashboardsPreviewDataMutation,
  usePostApiProjectsByProjectIdDashboardsWidgetRenderMutation,
  useGetApiProjectsByProjectIdDashboardsAndDashboardIdQuery,
  useLazyGetApiProjectsByProjectIdDashboardsAndDashboardIdQuery,
  usePutApiProjectsByProjectIdDashboardsAndDashboardIdMutation,
  useDeleteApiProjectsByProjectIdDashboardsAndDashboardIdMutation,
  usePostApiProjectsByProjectIdDashboardsAndDashboardIdRefreshMutation,
  useGetApiProjectsByProjectIdDashboardsAndDashboardIdRowsQuery,
  useLazyGetApiProjectsByProjectIdDashboardsAndDashboardIdRowsQuery,
  useGetApiProjectsByProjectIdDashboardsAndDashboardIdVersionsQuery,
  useLazyGetApiProjectsByProjectIdDashboardsAndDashboardIdVersionsQuery,
  useGetApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumberQuery,
  useLazyGetApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumberQuery,
  usePostApiProjectsByProjectIdDashboardsAndDashboardIdVersionsNumberRestoreMutation,
  useGetApiProjectsByProjectIdStudioBrandQuery,
  useLazyGetApiProjectsByProjectIdStudioBrandQuery,
  usePutApiProjectsByProjectIdStudioBrandMutation,
  usePostApiProjectsByProjectIdStudioBrandFromSiteMutation,
  useGetApiProjectsByProjectIdStudioDocumentsQuery,
  useLazyGetApiProjectsByProjectIdStudioDocumentsQuery,
  usePostApiProjectsByProjectIdStudioDocumentsMutation,
  useGetApiProjectsByProjectIdStudioDocumentsAndDocumentIdQuery,
  useLazyGetApiProjectsByProjectIdStudioDocumentsAndDocumentIdQuery,
  useDeleteApiProjectsByProjectIdStudioDocumentsAndDocumentIdMutation,
  usePatchApiProjectsByProjectIdStudioDocumentsAndDocumentIdMutation,
  usePostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRenderMutation,
  useGetApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersQuery,
  useLazyGetApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersQuery,
  usePostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersRenderIdOpenMutation,
  usePostApiProjectsByProjectIdStudioDocumentsAndDocumentIdRendersRenderIdVideoMutation,
  useGetApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsQuery,
  useLazyGetApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsQuery,
  usePostApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsMutation,
  useGetApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumberQuery,
  useLazyGetApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumberQuery,
  usePostApiProjectsByProjectIdStudioDocumentsAndDocumentIdVersionsNumberRestoreMutation,
  usePostApiProjectsByProjectIdStudioRenderMutation,
  useGetApiPublicDashboardsWidgetContentByTokenQuery,
  useLazyGetApiPublicDashboardsWidgetContentByTokenQuery,
  useGetApiPublicDashboardsByDashboardIdQuery,
  useLazyGetApiPublicDashboardsByDashboardIdQuery,
  useGetApiPublicStudioRendersByTokenQuery,
  useLazyGetApiPublicStudioRendersByTokenQuery,
  useGetApiPublicStudioRendersByTokenMp4Query,
  useLazyGetApiPublicStudioRendersByTokenMp4Query,
  useGetApiPublicStudioRendersByTokenPagesAndNumberQuery,
  useLazyGetApiPublicStudioRendersByTokenPagesAndNumberQuery,
  useGetApiPublicStudioRendersByTokenPdfQuery,
  useLazyGetApiPublicStudioRendersByTokenPdfQuery,
} = injectedRtkApi;
